<div mat-dialog-title class="ds">
  <span>{{ appStrings.lead_rejectLead_title }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="content ds">
  <form [formGroup]="selectForm">
    <ds-multiline id="reject-reason"
      class="no-subscript"
      [label]="appStrings.accounts_deleteLead_reasonTitle"
      label_orientation="vertical-label"
      [control]="selectForm.controls.reason">
    </ds-multiline>
  </form>
</div>

<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeButton" type="secondary" size="medium" variant="label-only"
      [label]="appStrings.button_cancel" (onClick)="close()">
    </ds-button>
    <ds-button id="rejectLeadButton" type="primary" size="medium" variant="label-only"
      [label]="appStrings.button_confirm" (onClick)="rejectLead()"
      [isDisabled]="selectForm.invalid">
    </ds-button>
  </div>
</div>
